export const carrierLinks: Record<string, string> = {
  'banner-life':
    'https://www.policygenius.com/life-insurance/reviews/banner-life-family-of-companies/',
  brighthouse: 'https://www.policygenius.com/life-insurance/reviews/brighthouse/',
  'lincoln-national-life': 'https://www.policygenius.com/life-insurance/reviews/lincoln-financial/',
  'mutual-of-omaha': 'https://www.policygenius.com/life-insurance/reviews/mutual-of-omaha/',
  'pacific-life': 'https://www.policygenius.com/life-insurance/reviews/pacific-life/',
  'principal-financial-group':
    'https://www.policygenius.com/life-insurance/reviews/principal-financial/',
  protective: 'https://www.policygenius.com/life-insurance/reviews/protective/',
  prudential: 'https://www.policygenius.com/life-insurance/reviews/prudential/',
  sbli: 'https://www.policygenius.com/life-insurance/reviews/sbli/',
  symetra: 'https://www.policygenius.com/life-insurance/reviews/symetra/',
  transamerica: 'https://www.policygenius.com/life-insurance/reviews/transamerica/',
  aig: 'https://www.policygenius.com/life-insurance/reviews/corebridge-financial',
};
